import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ChatService from "../../services/ChatService";
import { toast } from "react-toastify";

export const fetchChatList = createAsyncThunk(
  "chats/fetchChatList",
  async () => {
    try {
      const res = await ChatService.getChatList();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchMessageList = createAsyncThunk(
  "chats/fetchMessageList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ChatService.getMessageList(data);
      return res;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
      return error;
    }
  }
);

export const sendMessage = createAsyncThunk(
  "chats/sendMessage",
  async (data, thunkAPI) => {
    try {
      const res = await ChatService.sendMessage(data);
      if (res.status == 1) {
        // toast.success(res.message);
        return res;
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  chats: [],
  messages: [],
  total_pages: 0,
  total_records: 0,
};

const chatSlice = createSlice({
  name: "chats",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get Chats
    builder
      .addCase(fetchChatList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChatList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.chats = payload.data;
      })
      .addCase(fetchChatList.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(sendMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendMessage.fulfilled, (state, { payload }) => {
        state.loading = false;
        // state.chats = payload.data;
      })
      .addCase(sendMessage.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchMessageList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMessageList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.messages = payload.data.reverse();
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchMessageList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default chatSlice.reducer;
